import React, {useContext, useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import {changeTextCamal, checkRole, convertToAMPM} from '../../../_metronic/helpers'
import CustomTextInput from '../../components/CustomInput/CustomTextInput'
import {handleInputChange, handleOtherInputChange} from '../../CommonFunction'
import Select2 from '../../components/select2'
import {MultiSelect} from '@mantine/core'
import CustomMultiSelect from '../../components/CustomInput/CustomMultiSelect'
import SubmitCancleButton from '../../components/SubmitCancelButton'
import {getGeneralSettingData, handleSubmit, validateGeneralSettingForm} from './helperFunctions'
import {updateGeneralConfiguration} from '../../../api/ConfigurationAPI'
import {RoleContextValue} from '../../types/OtherTypes'
import roleContext from '../../context/roleContext'
import {GeneralSettingInput} from '../../types/SettingModuleTypes'
import {GeneralSettingInitialInput} from '../../data/SettingModulesDefaultData'

const GeneralSetting = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  const [editId, setEditID] = useState(false)
  const [inputError, setInputError] = useState<any>({})
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })

  const [inputField, setInputField] = useState<GeneralSettingInput>(GeneralSettingInitialInput)
  useEffect(() => {
    let mounted = true
    if (mounted) {
      getGeneralSettingData(setSubmitAPIStatus, setInputField)
    }
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className='row justify-content-center'>
      <div className='card col-5'>
        <div
          className='card-header'
          // hidden={!checkRole(['general_config'], roleState.features)}
        >
          <div className='card-title'>General Setting</div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
              <div
                className='card-toolbar'
                hidden={!checkRole(['general_config'], roleState.features)}
              >
                <i className='far fa-edit cursor-pointer fs-3' onClick={() => setEditID(true)}></i>
              </div>
            </div>
          </div>
        </div>
        <div className='card-body'>
          <Row className='mb-4'>
            <Col className='mb-3' md={4}>
              <label className=' fw-bold fs-6 text-muted'>Year Start Date</label>
            </Col>
            <Col className='mb-3' md={7}>
              {!editId ? (
                <span className='fw-bolder fs-6 text-dark'>
                  {changeTextCamal(inputField?.fiscal_year_start_date ?? '-')}{' '}
                </span>
              ) : (
                <CustomTextInput
                  type='date'
                  name='fiscal_year_start_date'
                  value={inputField?.fiscal_year_start_date}
                  onChange={(e) => {
                    handleInputChange(e, setInputField, inputError, setInputError)
                  }}
                  error={inputError.fiscal_year_start_date}
                />
              )}
            </Col>
            <Col className='mb-3' md={1}></Col>
            <Col className='mb-3' md={4}>
              <label className=' fw-bold fs-6 text-muted'>Year End Date</label>
            </Col>
            <Col className='mb-3' md={7}>
              {!editId ? (
                <span className='fw-bolder fs-6 text-dark'>
                  {changeTextCamal(inputField?.fiscal_year_end_date ?? '-')}{' '}
                </span>
              ) : (
                <CustomTextInput
                  type='date'
                  name='fiscal_year_end_date'
                  value={inputField?.fiscal_year_end_date}
                  onChange={(e) => {
                    handleInputChange(e, setInputField, inputError, setInputError)
                  }}
                  error={inputError.fiscal_year_end_date}
                />
              )}
            </Col>
            <Col className='mb-3' md={4}>
              <label className=' fw-bold fs-6 text-muted'>Weekends</label>
            </Col>
            <Col className='mb-3' md={7}>
              {!editId ? (
                <span className='fw-bolder fs-6 text-dark'>
                  {' '}
                  {inputField?.weekends?.map((obj, index) => {
                    return index + 1 === inputField?.weekends?.length
                      ? changeTextCamal(obj)
                      : `${changeTextCamal(obj)},`
                  })}{' '}
                </span>
              ) : (
                <CustomMultiSelect
                  name='weekends'
                  data={[
                    {label: 'Monday', value: 'Monday'},
                    {label: 'Tuesday', value: 'Tuesday'},
                    {label: 'Wednesday', value: 'Wednesday'},
                    {label: 'Thursday', value: 'Thursday'},
                    {label: 'Friday', value: 'Friday'},
                    {label: 'Saturday', value: 'Saturday'},
                    {label: 'Sunday', value: 'Sunday'},
                  ]}
                  value={inputField?.weekends}
                  onChange={(e: any) => {
                    handleOtherInputChange(e, 'weekends', setInputField, inputError, setInputError)
                  }}
                  error={inputError?.weekends}
                  multiple={true}
                />
              )}
            </Col>
            <Col className='mb-3' md={1}></Col>
            <Col className='mb-3' md={4}>
              <label className=' fw-bold fs-6 text-muted'>Week Start Day</label>
            </Col>
            <Col className='mb-3' md={7}>
              {!editId ? (
                <span className='fw-bolder fs-6 text-dark'>
                  {changeTextCamal(inputField?.week_start_day) ?? '-'}{' '}
                </span>
              ) : (
                <Select2
                  name='week_start_day'
                  data={[
                    {label: 'Monday', value: 'Monday'},
                    {label: 'Tuesday', value: 'Tuesday'},
                    {label: 'Wednesday', value: 'Wednesday'},
                    {label: 'Thursday', value: 'Thursday'},
                    {label: 'Friday', value: 'Friday'},
                    {label: 'Saturday', value: 'Saturday'},
                    {label: 'Sunday', value: 'Sunday'},
                  ]}
                  value={inputField?.week_start_day}
                  onChange={(e: any) => {
                    handleOtherInputChange(
                      e,
                      'week_start_day',
                      setInputField,
                      inputError,
                      setInputError
                    )
                  }}
                  error={inputError?.week_start_day}
                />
              )}
            </Col>
            <Col className='mb-3' md={4}>
              <label className=' fw-bold fs-6 text-muted'>In Time</label>
            </Col>
            <Col className='mb-3' md={7}>
              {!editId ? (
                <span className='fw-bolder fs-6 text-dark'>
                  {convertToAMPM(inputField?.inTime ?? '-')}{' '}
                </span>
              ) : (
                <CustomTextInput
                  type='time'
                  name='inTime'
                  value={inputField?.inTime}
                  onChange={(e) => {
                    handleInputChange(e, setInputField, inputError, setInputError)
                  }}
                  error={inputError.inTime}
                />
              )}
            </Col>
            <Col className='mb-3' md={1}></Col>
            <Col className='mb-3' md={4}>
              <label className=' fw-bold fs-6 text-muted'>Out Time</label>
            </Col>
            <Col className='mb-3' md={7}>
              {!editId ? (
                <span className='fw-bolder fs-6 text-dark'>
                  {convertToAMPM(inputField?.outTime ?? '-')}{' '}
                </span>
              ) : (
                <CustomTextInput
                  type='time'
                  name='outTime'
                  value={inputField?.outTime}
                  onChange={(e) => {
                    handleInputChange(e, setInputField, inputError, setInputError)
                  }}
                  error={inputError.outTime}
                />
              )}
            </Col>
          </Row>
        </div>
        {editId && (
          <SubmitCancleButton
            cancle={{
              onClick: () => {
                getGeneralSettingData(setSubmitAPIStatus, setInputField)
                setInputError({})
                setEditID(false)
              },
            }}
            submit={{
              // editid: editId,
              loading: SubmitAPIStatus.loading,
              onClick: () =>
                handleSubmit(
                  getGeneralSettingData,
                  '',
                  inputField,
                  GeneralSettingInitialInput,
                  setInputField,
                  setInputError,
                  validateGeneralSettingForm,
                  setSubmitAPIStatus,
                  updateGeneralConfiguration,
                  setEditID
                ),
            }}
          />
        )}
      </div>
    </div>
  )
}

export default GeneralSetting
